export default "__VITE_ASSET__DpCEanrh__"